import { asLink } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next";
import { textToSlug } from "@/helpers";

/**
 * @typedef {import("@prismicio/client").Content.BlogSliceRichTextPrimary} RichTextPrimary
 * @param {{ primary: RichTextPrimary }} props
 */
const RichText = ({ primary }) => (
  <PrismicRichText
    field={primary.rich_text}
    components={{
      heading2: ({ children, text }) => (
        <h2 id={textToSlug(text)} className="sumup-trigger h2-n lg:dk text-bleu mb-10">
          {children}
        </h2>
      ),
      heading3: ({ children }) => <h3 className="h3-n lg:dk text-bleu my-7 first:mt-0">{children}</h3>,
      heading4: ({ children }) => <h4 className="h4-n lg:dk text-bleu">{children}</h4>,
      heading5: ({ children }) => <h5 className="h5-n lg:dk text-bleu">{children}</h5>,
      heading6: ({ children }) => <h6 className="h6-n lg:dk text-bleu">{children}</h6>,
      paragraph: ({ children }) => (
        <p className="p-base-n nm text-bleu-90 [p+&]:mt-5">{children}</p>
      ),
      br: () => <br className="my-5" />,
      strong: ({ children }) => <strong className="p-base-n sbd">{children}</strong>,
      list: ({ children }) => <ul className="my-5 pl-3">{children}</ul>,
      listItem: ({ children }) => (
        <li className="my-4 flex items-start gap-3 p-base-n nm text-bleu-90">
          <img
            src="/icons/bullet-point.svg"
            alt=""
            width={4}
            height={4}
            className="size-1 shrink-0 mt-2.5"
            aria-hidden
          />
          <span>{children}</span>
        </li>
      ),
      hyperlink: ({ children, node }) =>
        asLink(node.data) ? (
          <PrismicNextLink field={node.data} prefetch={false} className="p-base-n sbd text-vert underline">
            {children}
          </PrismicNextLink>
        ) : (
          <span>{children}</span>
        ),
    }}
  />
);

export default RichText;
